export type SupportedCardBrand =
  | 'visa'
  | 'master-card'
  | 'amex'
  | 'jcb'
  | 'dinersclub'

export const mapDetectedBrandToSupported = (
  raw: string | null | undefined,
): SupportedCardBrand | '' => {
  if (!raw) return ''
  if (raw === 'mastercard') return 'master-card'
  if (
    raw === 'visa' ||
    raw === 'amex' ||
    raw === 'jcb' ||
    raw === 'dinersclub'
  ) {
    return raw
  }
  return ''
}
